import addTargetEventListener from 'mex_components/app/scripts/events/addTargetEventListener.js';

addTargetEventListener('click', '.accordion__symbol-section', function (event) {
  event.preventDefault();

  const accordionContent = this.closest('.accordion').nextElementSibling;
  const hiddenClass = 'js-accordion__content--hidden';
  accordionContent.classList.toggle(hiddenClass);
  if(accordionContent.classList.contains(hiddenClass)) {
    this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21"
      viewBox="0 0 21 21" stroke="currentColor">
      <line y1="10.5" x2="21" y2="10.5" /><line x1="10.5" y1="21" x2="10.5" /></svg>`;
  } else {
    this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21"
      stroke="currentColor" viewBox="0 0 21 21"><line y1="10.5" x2="21" y2="10.5" /></svg>`;
  }
});
